import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonFile } from './upload.interface'

@Component({
  selector: 'icos-upload-list',
  template: `
    <ul [class]="'icos-upload-list icos-upload-list--' + listType"
      [class.is-disabled]="icosDisabled">
      <li *ngFor="let file of files; let i = index"
        [class]="'icos-upload-list__item is-' + file.status">
        <img class="icos-upload-list__item-thumbnail"
          *ngIf="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1"
          [src]="file.url">
        <a class="icos-upload-list__item-name" (click)="clickHandle(file)">
          <i class="icos-icon-document"></i>
          {{file.name}}
        </a>
        <label class="icos-upload-list__item-status-label">
          <i [class.icos-icon-check]="['picture-card', 'picture'].indexOf(listType) > -1"
            [class.icos-icon-circle-check]="listType === 'text'"
            [class.icos-icon-upload-success]="true"></i>
        </label>
        <i class="icos-icon-close" *ngIf="!icosDisabled" (click)="removeHandle(file)"></i>
        <icos-progress *ngIf="file.status === 'uploading'"
          [type]="listType === 'picture-card' ? 'circle' : 'line'"
          [stroke-width]="listType === 'picture-card' ? 6 : 2"
          [percentage]="file.percentage">
        </icos-progress>
        <span class="icos-upload-list__item-actions" *ngIf="listType === 'picture-card'">
        <span class="icos-upload-list__item-preview"
          *ngIf="listType === 'picture-card'"
          (click)="previewHandle(file)">
          <i class="icos-icon-view"></i>
        </span>
        <span class="icos-upload-list__item-delete"
          *ngIf="!icosDisabled"
          (click)="removeHandle(file)">
          <i class="icos-icon-delete2"></i>
        </span>
      </span>
      </li>
    </ul>
  `,
})
export class IcosUploadList {

  @Input() files: CommonFile[] = []
  @Input() icosDisabled: boolean = false
  @Input('list-type') listType: string
  @Output() remove: EventEmitter<CommonFile> = new EventEmitter<CommonFile>()
  @Output() preview: EventEmitter<CommonFile> = new EventEmitter<CommonFile>()

  clickHandle(file: CommonFile): void {

  }

  removeHandle(file: CommonFile): void {
    this.remove.emit(file)
  }


  previewHandle(file: CommonFile): void {
    this.preview.emit(file)
  }

}

